// initializing 
(function() {
  $(document).ready(function() {
    SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
    SwellConfig.LocalStorage.initializeLocalStorage();

    $( 'body' ).on('click',".premier-store-post-checkout .checkout-heading .swell-referral-back-link", function() {
      $(".premier-store-post-checkout").hide();
    });
    
    $(document).on("click", ".swell-share-referral-copy", function(){
       setTimeout(function(){
         $(".swell-referral-content").append($(".swell-referral-copy").detach());
         $(".swell-referral-copy").show();
       }, 10);
    });
    
    $( document ).on('click',"#swell-referral-register-submit", function() {
      setTimeout(function(){
        if(spapi.customer.referral_receipts) {
          setupReferrals();
          if(spapi.customer.email) {
           $(".swell-referral-content-main").addClass("refer-step");
          }
        } else {
          setTimeout(function(){
            setupReferrals();
            if(spapi.customer.email) {
             $(".swell-referral-content-main").addClass("refer-step");
            }
          },1000)
        }
      },1000)
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function(){
        var customerDetails = swellAPI.getCustomerDetails();
        referrals = customerDetails.referrals;

        $(".redeem-holder").show();

        $(".swell-referral-table tbody").html("");

        referrals.forEach(function(referral) {
          status = null;

          if(referral.completedAt){ 
            status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
          } else {
            status = "Invited";
          }

          $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
        });
      });
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) { 
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        $(".refer-customer-error").remove();
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
      }
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) { 
      if(textStatus && textStatus === "Please enter a valid email address"){
          $(".refer-customer-error").remove();
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
    });
  });

  $(document).on("swell:setup", function() {
    
    $(".premier-store-post-checkout").show();
    $(".swell-referral-loader").hide();

    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    SwellConfig.Referral.initializeReferral(".swell-referral");
    SwellConfig.Customer.initializeHistory(".swell-history-link");
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".swell-tier-list");
    SwellConfig.Redemption.initializeSlider(".swell-tier-list");

    if(spapi.customer.email) {
     $(".swell-referral-content-main").addClass("refer-step");
    }
    setupReferrals();
    if(spapi.isMobile) {
      $(".swell-share-referral-sms").show();
    }
  });
}).call(this);

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign">  <div    class="swell-campaign-content"    data-display-mode="modal"   data-campaign-id="<%= campaign.id %>">   <div class="swell-campaign-icon">      <span class="swell-campaign-icon-content"><span class="<%= campaign.icon %>"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span></span>    </div>    <div class="swell-campaign-value">      <span class="swell-campaign-value-content"><%= campaign.reward_text %></span>    </div>    <div class="swell-campaign-type">      <span class="swell-campaign-type-content"><%= campaign.title %></span>    </div>  </div></li>'
      }
    }
  };
}).call(this);

function setupReferrals (){
  if(spapi.customer.email) {
    if(spapi.customer.referral_receipts.length > 0) {
      $(".redeem-holder").show();

      referrals = spapi.customer.referral_receipts;

      referrals.forEach(function(referral) {
        status = null;

        if(referral.completed_at){ 
          status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
        } else {
          status = "Invited";
        }

        $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
      });  
    }
  }
}

// history popup
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Customer = {
    initializeHistory: function(containerSelector) {
      return $(containerSelector).click(function() {
        return swellAPI.showPopupByType("HistoryPopup");
      });
    }
  };
}).call(this);

// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

// redemption
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    initializeSlider: function(containerSelector){
      if($(containerSelector).length === 0) {
        return "";
      }
      $('.swell-tier-list').slick({
        slidesToShow: 3,
        arrows: false,
        responsive: [
         {
           breakpoint: 768,
           settings: {
            centerMode: true,
            centerPadding: '40px',
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-right slick-arrow-right"></i>',
            prevArrow: '<i class="fa fa-chevron-left slick-arrow-left"></i>',
            slidesToScroll: 1,
             slidesToShow: 1
           }
         }
       ]
      });
    }
  };
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: "<span> refer a friend </span> Give <span class='referral-reward'>$10</span>, Get <span class='referral-reward'><%= referralCampaign.reward_text %></span>",
        referralRegisterFormDetails: "Please submit your email below to get started.",
        referralRegisterFormEmail: "Your Email Address",
        referralRegisterFormSubmit: "Next",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "<span> refer a friend </span> Give <span class='referral-reward'>$10</span>, Get <span class='referral-reward'><%= referralCampaign.reward_text %></span>",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "Next",
        referralReferFormDetails: "Now, enter your friends' emails below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below",

        referralShareFacebook: "Share",
        referralShareTwitter: "Twitter",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Messenger",
        referralShareSMS: "SMS",

        referralFacebookIcon: "swell-icon-facebook2",
        referralTwitterIcon: "swell-icon-twitter",
        referralLinkIcon: "swell-icon-link",
        referralMessengerIcon: "swell-icon-messenger",
        referralSMSIcon: "swell-icon-message",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy and share link with your friends"
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> <li class="swell-referral-form-list-field"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </div> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareSMS%> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"> <span class="path1"></span> <span class="path2"></span> </i> &nbsp; <span><%= localization.referralShareMessenger %> </span> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    }
  };
}).call(this);

// tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
     var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
     customer_tier_id = SwellConfig.Tier.getCustomerTierId();
     customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
     next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);

     tiers = spapi.activeVipTiers;
     tiers.forEach(function(tier) {
       if(tier.id  == customer_tier_id) {
         customer_tier = tier;
       }
     });

     tiers.forEach(function(tier) {
        if(tier.rank == customer_tier.rank) {
         $("li[data-tier-id="+ tier.id +"] .swell-tier-status").html("Current Status");
       } else if (next_tier && tier.rank == next_tier.rank) {
         if(spapi.customer.vip_tier_stats) {
           tier_difference = (tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents)/100;
         } else {
           tier_difference = (tier.amount_spent_cents - 0)/100;
         }
         $("li[data-tier-id="+ tier.id +"] .swell-tier-status").html('Spend $' + tier_difference + ' more to earn ' + tier.name);
       }
     });
   },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].spend_required = "Qualified Annual Spend " + spapi.activeVipTiers[0].prettyAmountSpent; // + "&ndash;$" + ((spapi.activeVipTiers[1].amount_spent_cents/100)-1).toString();
      spapi.activeVipTiers[0].points_multiplier = spapi.activeVipTiers[0].points_multiplier;
      spapi.activeVipTiers[0].points = "100";
      spapi.activeVipTiers[0].discount = "";

      spapi.activeVipTiers[1].spend_required = "Qualified Annual Spend " + spapi.activeVipTiers[1].prettyAmountSpent;// + "&ndash;$" + ((spapi.activeVipTiers[2].amount_spent_cents/100)-1).toString();
      spapi.activeVipTiers[1].points_multiplier = spapi.activeVipTiers[1].points_multiplier;
      spapi.activeVipTiers[1].points = "150";
      spapi.activeVipTiers[1].discount = "";
      
      spapi.activeVipTiers[2].spend_required = "Qualified Annual Spend " + spapi.activeVipTiers[2].prettyAmountSpent + "+";
      spapi.activeVipTiers[2].points_multiplier = spapi.activeVipTiers[2].points_multiplier;
      spapi.activeVipTiers[2].points = "200";
      spapi.activeVipTiers[2].discount = "";
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      
      tiers.forEach(function(tier) {
        if(tier.rank == 0){
          $(containerSelector).append('<li data-tier-id="' + tier.id + '" class="list-items tier' + tier.rank +'"> <div class="items-holder"> <div class="items-heading-holder"> <div class="tier_spend">' + tier.spend_required +'</div> <div class="name">' + tier.name +'</div> </div> <div class="swell-tier-status"> </div> <ul class="point-holder"> <li class="points_multiplier">' + tier.points_multiplier +'<span>Points Per $ Spent</span></li> <li>' + tier.points +' Points upon Entering ' + tier.name +' Status</li> </ul> </div> </li>');
        } else {
          $(containerSelector).append('<li data-tier-id="' + tier.id + '" class="list-items tier' + tier.rank +'"> <div class="items-holder"> <div class="items-heading-holder"> <div class="tier_spend">' + tier.spend_required +'</div> <div class="name">' + tier.name +'</div> </div> <div class="swell-tier-status"> </div> <ul class="point-holder"> <li class="points_multiplier">' + tier.points_multiplier +'<span>Points Per $ Spent</span></li> <li>' + tier.points +' Points upon Entering ' + tier.name +' Status</li> </ul> </div> </li>');
        }
      });

      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };
}).call(this);
